"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vars = exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _sharedTypes = require("../../components/sharedTypes");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _getContrastingTextColor = require("../../utils/getContrastingTextColor");
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../utils/pickAndRemoveFromObject"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _warning = _interopRequireDefault(require("../../utils/warning"));
var _excluded = ["overrides", "defaultChecked", "disabled", "onCheck", "label", "className", "checked", "labelSide", "id", "name", "hint", "description", "wrapperProps", "color", "primary"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var common = _commonProps.defaultCommonProps;
var vars = exports.vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "checkboxPrimary"
  }, {
    key: "checkboxColor"
  }]
});
var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$overrides = _ref.overrides,
    overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    onCheck = _ref.onCheck,
    label = _ref.label,
    className = _ref.className,
    checked = _ref.checked,
    _ref$labelSide = _ref.labelSide,
    labelSide = _ref$labelSide === void 0 ? _sharedTypes.LabelSide.RIGHT : _ref$labelSide,
    id = _ref.id,
    name = _ref.name,
    hint = _ref.hint,
    description = _ref.description,
    wrapperProps = _ref.wrapperProps,
    color = _ref.color,
    primary = _ref.primary,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var theme = (0, _reactJss.useTheme)();
  var classes = useStyles(vars.useVars(_objectSpread({
    checkboxColor: color,
    checkboxPrimary: primary ? theme.colors.primary : color
  }, (0, _pickAndRemoveFromObject.default)(otherProps, common))));
  process.env.NODE_ENV !== "production" ? (0, _warning.default)(name, "Always add the name prop to input components!") : void 0;
  var onChange = function onChange(ev) {
    if (onCheck) {
      onCheck(ev.target.checked, ev);
    }
  };
  var inputProps = _objectSpread({
    id: id !== null && id !== void 0 ? id : name,
    name: name,
    type: "checkbox",
    defaultChecked: defaultChecked,
    onChange: onChange,
    className: (0, _classnames.default)(classes.input, _defineProperty({}, classes.disabled, disabled), className),
    disabled: disabled,
    checked: checked
  }, otherProps);
  var labelProps = {
    htmlFor: inputProps.id,
    className: (0, _classnames.default)(classes.label, _defineProperty({}, classes.flip, labelSide === _sharedTypes.LabelSide.LEFT))
  };
  var rootProps = _objectSpread(_objectSpread({}, wrapperProps), {}, {
    className: (0, _classnames.default)(classes.variables, classes.root, wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.className, overrides.root)
  });
  return /*#__PURE__*/_react.default.createElement("div", rootProps, /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: ref
  }, inputProps)), /*#__PURE__*/_react.default.createElement("label", labelProps, /*#__PURE__*/_react.default.createElement("svg", {
    className: (0, _classnames.default)(classes.svg, overrides.svg),
    viewBox: "0 0 12 10"
  }, /*#__PURE__*/_react.default.createElement("polyline", {
    points: "1.5 6 4.5 9 10.5 1"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.labelText, overrides.label)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.labelTextSpan)
  }, label), hint && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.hint)
  }, "\xA0(", hint, ")"), description && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.description)
  }, description))));
});
var styles = function styles(theme) {
  var size = 18;
  return {
    variables: vars.styles,
    root: {
      position: "relative",
      display: "flex",
      fontFamily: theme.typography.fontFamily
    },
    input: {
      opacity: 0,
      zIndex: 1,
      cursor: "pointer",
      position: "absolute",
      width: "100%",
      height: "100%",
      fontFamily: "inherit",
      margin: 0,
      "&:checked + label svg": {
        backgroundColor: vars.get("checkboxColor", theme.colors.primary),
        borderColor: vars.get("checkboxColor", theme.colors.primary),
        strokeDashoffset: 0
      },
      "&:required + label": {
        "& $labelTextSpan": {
          display: "flex",
          "&:after": {
            content: '"\\002A"',
            color: theme.colors.alert,
            paddingLeft: theme.spacing.base / 2,
            paddingRight: theme.spacing.base / 2
          }
        }
      }
    },
    disabled: {
      cursor: "not-allowed",
      "&& + label": {
        "& svg": {
          borderColor: theme.colors.baseContrast030,
          boxShadow: "none"
        },
        "& $labelText": {
          color: theme.colors.baseContrast040
        }
      },
      "&:checked + label svg": {
        backgroundColor: theme.colors.baseContrast030,
        borderColor: theme.colors.baseContrast030
      }
    },
    label: {
      display: "flex",
      flexDirection: "row",
      fontFamily: "inherit",
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeight,
      lineHeight: "".concat(theme.spacing.base * 2.5, "px")
    },
    svg: {
      boxSizing: "border-box",
      width: size,
      height: size,
      minWidth: size,
      borderRadius: 3,
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: vars.get("checkboxPrimary", theme.colors.baseContrast060),
      fill: "none",
      stroke: (0, _getContrastingTextColor.getContrastingTextColorHexString)(theme.colors.primary, undefined, undefined, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD),
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: 16,
      strokeDashoffset: 16,
      transition: "all .3s ease",
      transform: "translate3d(0,0,0)",
      backgroundColor: "transparent",
      display: "flex",
      margin: 0,
      marginInlineEnd: theme.spacing.base
    },
    labelText: {
      fontFamily: "inherit",
      color: theme.colors.baseContrast070
    },
    labelTextSpan: {},
    flip: {
      flexDirection: "row-reverse",
      "& svg": {
        margin: 0,
        marginInlineStart: theme.spacing.base
      }
    },
    hint: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    description: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    }
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "Checkbox"
});
Checkbox.displayName = "Checkbox";
var Storybook = exports.Storybook = Checkbox;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/form-checkbox--docs
 */
var exportedComponent = (0, _defaultProps.default)(Checkbox);
exportedComponent.displayName = "Checkbox";
var _default = exports.default = exportedComponent;